import React, {useEffect, useState} from 'react';

import './styles.scss';
import {connect} from 'react-redux';
import {
  addToWizard,
  setGlobalStyles,
  setWizard,
  setIsLanguageSelected,
  setLanguage,
  setLanguageOptions,
  setBuDefaultStyles,
} from '../../store/actions';
import {compose} from 'redux';
import RegisterHeader from '../../components/headers/register-header';
import {Column, Row} from '../../components/layout';
import Header1 from '../../components/headers/header1';
import {functionalitiesAliasMap, strings} from '../../util/strings';
import * as fonts from '../../util/fonts';
import colors, {pageBackgrounds} from '../../util/colors';
import Stepper from '../../components/stepper';
import InsuranceValidation from './steps/insurance-validation';
import DataValidation from './steps/data-validation';
import Communications from './communications';
import AccountData from './steps/account-data';
import {uriGetBuStylesFromBuAlias} from '../../api/endpoints';
import {createGUID, updateStringFeatureWithLabels} from '../../util/utility';
import AppSpinner from '../../components/app-spinner';
import {withRouter} from 'react-router';
import {get} from '../../api/api';
import {
  AppForm,
  AppFormRadioField,
  AppFormSubmitButton,
} from '../../components/forms';
import * as Yup from 'yup';
import {ITenant} from '../../App';
import {deepStringObjectMerger} from '../../util/utility';

export interface RegisterPageProps {
  wizard: any;
  addToWizard(value: any): void;
  setGlobalStyles(value: any): void;
  labels: any;
  labelsMessages: typeof strings.pt.messages;
  isLanguageSelected: boolean;
  language: string;
  setLanguage(value: any): void;
  setIsLanguageSelected(value: any): void;
  setLanguageOptions(value: any): void;
  setBuDefaultStyles(value: any): void;
  languageOptions: any;
  tenant: ITenant;
  busFuncMapDefault: any;
}

const RegisterPage = ({
  wizard,
  addToWizard,
  setGlobalStyles,
  labels,
  labelsMessages,
  isLanguageSelected,
  language,
  setLanguage,
  setIsLanguageSelected,
  setLanguageOptions,
  languageOptions,
  tenant,
  busFuncMapDefault,
}: RegisterPageProps) => {
  const [currentStepValid, setCurrentStepValid] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isMultiLanguage, setIsMultiLanguage] = useState(
    busFuncMapDefault?.[functionalitiesAliasMap.multiLanguage]
  );
  const [currentLanguage, setCurrentLanguage] = useState(
    window.location.search?.split('=')[1]
  );
  const labelsRegister = labels?.pt?.register;

  const featureName = 'Register';
  const labelsToUse = deepStringObjectMerger(strings.pt.register, labels);
  const labelsMessagesToUse = deepStringObjectMerger(
    strings.pt.messages,
    labelsMessages
  );

  useEffect(() => {
    setCurrentLanguage(window.location.search?.split('=')[1]);
    setLanguage(window.location.search?.split('=')[1]);
    setTimeout(() => {
      setIsLoading(false);
    }, 4000);
  }, [window.location.search]);

  useEffect(() => {
    setIsMultiLanguage(
      busFuncMapDefault?.[functionalitiesAliasMap.multiLanguage]
    );
  }, [busFuncMapDefault]);

  useEffect(() => {
    if (tenant?.alias) {
      checkRedirect();
      getLanguageOptions();
      getDefaultBuStyles();
    }
  }, [tenant?.alias]);

  const getDefaultBuStyles = async () => {
    const busStyles = (await get(
      uriGetBuStylesFromBuAlias(tenant?.buDefaultAlias || 'ADV'),
      false,
      0,
      featureName
    )) as any;
    setGlobalStyles({
      ...busStyles?.data?.items?.[0],
      background: pageBackgrounds.registerPage,
    });
  };

  const getLanguageOptions = async () => {
    const languageOptions = tenant?.languages?.map((lng: any) => lng.alias);
    setLanguageOptions(languageOptions);
  };

  const checkRedirect = () => {
    if (!!tenant.alternativeRegistrationURL) {
      window.open(tenant.alternativeRegistrationURL, '_self');
    }
  };

  const userContacts =
    wizard?.dataValidation?.currentUser?.email ||
    wizard?.dataValidation?.currentUser?.phone;

  if (wizard.step > 0 && !!!wizard.communications) {
    return <Communications />;
  }

  const validationSchema = Yup.object().shape({});

  const renderLanguageOptions = (languageOptions: any) => {
    const result = languageOptions ? [...languageOptions] : [];

    const ptLangIndex = result.findIndex(
      (el: any) => el === labelsMessagesToUse?.default_language
    );
    if (ptLangIndex !== -1) {
      const ptLang = result.splice(ptLangIndex, 1);
      result.unshift(ptLang[0]);
    }

    return result.map((option: any) => ({
      label: labelsToUse?.[option],
      value: option,
    }));
  };

  return (
    <Column className="register-main-column">
      <RegisterHeader />
      <Column className="register-container">
        <Row className="register-header-row">
          {isLoading ? (
            <Header1
              style={{...fonts.XL, ...fonts.Bold, color: colors.black}}
              className="register-welcome-header">
              {labelsToUse?.register_pageTitle}
            </Header1>
          ) : (
            <Header1
              style={{...fonts.XL, ...fonts.Bold, color: colors.black}}
              className="register-welcome-header">
              {isMultiLanguage && !isLanguageSelected
                ? labelsToUse?.register_multi_language_pageTitle
                : labelsToUse?.register_pageTitle}
            </Header1>
          )}
        </Row>
        {isLoading ? (
          <AppSpinner
            type="grey"
            style={{
              width: 'fit-content',
              justifyContent: 'center',
              alignSelf: 'center',
            }}></AppSpinner>
        ) : isMultiLanguage && !isLanguageSelected ? (
          <AppForm
            validationSchema={validationSchema}
            initialValues={{
              selectedLanguage: language || currentLanguage,
            }}
            onSubmit={(values) => {
              setLanguage(values.selectedLanguage);
              setIsLanguageSelected(true);
              window.location.search = `?language=${values.selectedLanguage}`;
              setIsLoading(true);
              setCurrentLanguage(values.selectedLanguage);
            }}
            className="register-language-selector-form">
            <AppFormRadioField
              className="register-language-selector-radio-select"
              name="selectedLanguage"
              options={renderLanguageOptions(languageOptions)}
            />
            <div>
              <p
                className="register-language-selector-info"
                style={{
                  ...fonts.M,
                  color: colors.black,
                }}>
                {labelsToUse?.register_multi_language_info}
              </p>
              <AppFormSubmitButton
                title={labelsToUse?.contactActivation_buttonText}
                type="submit"
              />
            </div>
          </AppForm>
        ) : (
          <Stepper
            className="register-stepper"
            step={0}
            currentStepValid={currentStepValid}
            steps={[
              {
                index: 0,
                label: labelsToUse?.register_step1,
                component: (onSubmit: any, nextStepHandler: any) => (
                  <InsuranceValidation
                    onSubmit={onSubmit}
                    nextStep={nextStepHandler}
                    setValid={(valid) => {
                      if (valid !== currentStepValid)
                        setCurrentStepValid(valid);
                    }}
                    valid={currentStepValid}
                  />
                ),
                onSubmit: (values: any) =>
                  addToWizard({insuranceValidation: {...values}}),
              },
              {
                index: 1,
                label:
                  userContacts &&
                  Object.keys(userContacts).length > 0 &&
                  (userContacts.email !== '' || userContacts.phone !== '')
                    ? labelsToUse?.activation_title
                    : labelsToUse?.activationChoice_title,
                component: (onSubmit: any, nextStepHandler: any) => (
                  <DataValidation
                    onSubmit={onSubmit}
                    nextStep={nextStepHandler}
                    setValid={(valid: any) => {
                      if (valid !== currentStepValid)
                        setCurrentStepValid(valid);
                    }}
                    valid={currentStepValid}
                  />
                ),
                onSubmit: (values: any) =>
                  addToWizard({dataValidation: {...values}}),
              },
              {
                index: 2,
                label: labelsToUse?.emailAndPassword_pageTitle,
                component: (onSubmit: any, nextStepHandler: any) => (
                  <AccountData
                    language={language}
                    onSubmit={onSubmit}
                    nextStep={nextStepHandler}
                    setValid={(valid: any) => {
                      if (valid !== currentStepValid)
                        setCurrentStepValid(valid);
                    }}
                    valid={currentStepValid}
                  />
                ),
                onSubmit: (values: any) =>
                  addToWizard({ActivateAccount: {...values}}),
              },
            ]}
          />
        )}
      </Column>
    </Column>
  );
};

const mapStateToProps = ({
  wizard,
  stringsDefault,
  language,
  isLanguageSelected,
  languageOptions,
  tenant,
  busFuncMapDefault,
}: any) => ({
  wizard: wizard.value,
  labels: stringsDefault.value?.pt?.register,
  labelsMessages: stringsDefault.value?.pt?.messages,
  language: language.value,
  isLanguageSelected: isLanguageSelected.value,
  languageOptions: languageOptions.value,
  tenant: tenant.value,
  busFuncMapDefault: busFuncMapDefault.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  setWizard: (value: any) => dispatch(setWizard(value)),
  addToWizard: (value: any) => dispatch(addToWizard(value)),
  setGlobalStyles: (value: any) => dispatch(setGlobalStyles(value)),
  setIsLanguageSelected: (value: any) => dispatch(setIsLanguageSelected(value)),
  setLanguage: (value: any) => dispatch(setLanguage(value)),
  setLanguageOptions: (value: any) => dispatch(setLanguageOptions(value)),
  setBuDefaultStyles: (value: any) => dispatch(setBuDefaultStyles(value)),
});

export default compose(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(RegisterPage))
);
